import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import OutsideClickHandler from 'react-outside-click-handler';
import AddToCalendar from 'react-add-to-calendar';
import { withSizes } from 'react-sizes';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { beginBookingManagementProcess, openModal } from '../../redux/actions';

import { ManageSection, ManageContainer, ManageButton, ManageDropdown, ManageList } from './styles';

const mapSizesToProps = ({ width }) => ({
  isTablet: width >= 768,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  beginManagementProcess: beginBookingManagementProcess,
  handleModalOpen: openModal,
}, dispatch);

@withSizes(mapSizesToProps)
@connect(null, mapDispatchToProps)
class ManageBooking extends Component {
  static propTypes = {
    handleModalOpen: PropTypes.func,
    hotelName: PropTypes.string,
    checkinDate: PropTypes.string,
    address: PropTypes.string,
    status: PropTypes.number,
    isTablet: PropTypes.bool,
    productName: PropTypes.string,
  };

  state = {
    isOpen: false,
  };

  handleDropdownClick = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }))
  };

  handleDropdownClose = () => {
    this.setState({
      isOpen: false,
    })
  };

  handleAddToCalendarClick = () => {
    const { checkinDate, productName, hotelName, address } = this.props;

    return {
      title: `${productName} at ${hotelName}`,
      description: 'Thank you for booking with DayAxe.com',
      location: address,
      startTime: checkinDate,
      endTime: checkinDate,
    };
  };

  onDropdownActionClick = type => {
    const { handleModalOpen } = this.props;
    handleModalOpen(type);
  };

  render() {

    const { handleDropdownClick, handleDropdownClose, handleAddToCalendarClick, onDropdownActionClick } = this;
    const { isOpen } = this.state;
    const { isTablet, status, checkinDate } = this.props;

    const cancelationPeriodCheck = !moment.utc().add(process.env.CANCELING_HOURS,'hour').isAfter(moment.utc(checkinDate).startOf('day'));

    const isActive = status === 0;
    const isRedeemed = status === 2;

    const event = handleAddToCalendarClick();
    const items = [
      { outlook: 'Download' },
      { google: 'Google Calendar' }
    ];

    if (isTablet) {
      return (
        <ManageContainer>
          <OutsideClickHandler onOutsideClick={handleDropdownClose}>
            {((isActive && cancelationPeriodCheck)  || isRedeemed) && (
              <ManageButton type="button" isOpen={isOpen} onClick={handleDropdownClick}>Manage</ManageButton>
            )}
            {isOpen && (
              <ManageDropdown>
                {cancelationPeriodCheck && !isRedeemed && (
                  <Fragment>
                    <li>
                      <button type="button" onClick={() => onDropdownActionClick('calendar')}>Change Check-in Date</button>
                    </li>
                    <li>
                      <button type="button" onClick={() => onDropdownActionClick('addGuest')}>Add Guests</button>
                    </li>
                  </Fragment>
                )}
                {!isRedeemed && (
                  <li>
                    <AddToCalendar event={event} buttonLabel="Add to Calendar" listItems={items} />
                  </li>
                )}
                {cancelationPeriodCheck && !isRedeemed &&(
                  <Fragment>
                    <li>
                      <button type="button" className="cancel" onClick={() => onDropdownActionClick('cancelTicket')}>Cancel</button>
                    </li>
                  </Fragment>
                )}
                {isRedeemed && (
                  <li>
                    <button type="button" onClick={() => onDropdownActionClick('review')}>Submit Review</button>
                  </li>
                )}
              </ManageDropdown>
            )}
          </OutsideClickHandler>
        </ManageContainer>
      )
    }

    return (
      <ManageSection>
        <ManageList>
          {cancelationPeriodCheck && !isRedeemed && (
            <Fragment>
              <li>
                <button type="button" onClick={() => onDropdownActionClick('calendar')}>Change Check-in Date</button>
              </li>
              <li>
                <button type="button" onClick={() => onDropdownActionClick('addGuest')}>Add Guests</button>
              </li>
            </Fragment>
          )}
          {!isRedeemed && (
            <li>
              <AddToCalendar event={event} buttonLabel="Add to Calendar" listItems={items} />
            </li>
          )}
          {isRedeemed && (
            <li>
              <button type="button" onClick={() => onDropdownActionClick('review')}>Submit Review</button>
            </li>
          )}
          {cancelationPeriodCheck && !isRedeemed &&(
            <Fragment>
              <li>
                <button type="button" className="cancel" onClick={() => onDropdownActionClick('cancelTicket')}>Cancel</button>
              </li>
            </Fragment>
          )}
        </ManageList>
      </ManageSection>
    );
  }
}

export default ManageBooking;
